import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    shortlistStateKey,
    getShortlistFiltersLabel
} from '../../helpers/shortlistUtils';

class FiltersLabel extends PureComponent {
    static propTypes = {
        dataTable: PropTypes.object.isRequired,
        refinement: PropTypes.object.isRequired,
        refinementHistory: PropTypes.array.isRequired,
        data: PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.dataTable !== nextProps.dataTable && !nextProps.dataTable.loading;
    }

    render() {
        const { refinement, refinementHistory, data } = this.props;
        return (
            <span
                className="sales__HeaderFilterLabel_text"
                data-test-selector="filters_applied"
            >
                {getShortlistFiltersLabel({ refinement, refinementHistory, data })}
            </span>
        );
    }
}

const mapStateToProps = (state) => {
    const { dataTable, refinement, refinementHistory, data } = state[shortlistStateKey];
    return {
        dataTable,
        refinement,
        refinementHistory,
        data
    };
};

export default connect(mapStateToProps)(FiltersLabel);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/FiltersLabel.js